<template>
  <div class="container">
    <h1 class="py-4">Push通知管理</h1>
    <h2>対象ユーザ抽出</h2>
    <p class="bottomborder">アプリデータ管理</p>
    <div class="form-row">
      <div class="form-group col-md-6">
        <p>カード種類</p>
        <select class="form-control" name="card_type" v-model="card_type">
          <option value=""></option>
          <option
            v-for="(item, index) in this.card_type_codes"
            :value="index"
            :key="index"
          >
            {{ item }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <p>性別</p>
        <select class="form-control" name="sexfilter" v-model="sexfilter">
          <option value=""></option>
          <option v-for="(item, index) in this.sex" :value="index" :key="index">
            {{ item }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <input v-model="valid_member_flag" type="checkbox" /> 有効会員のみを抽出
      </div>
    </div>
    <p class="bottomborder">c.choysan連携データ</p>
    <div class="form-row">
      <div class="form-group col-md-6">
        <p>業種</p>
        <select class="form-control" name="industry" v-model="industry">
          <option value=""></option>
          <option
            v-for="option in this.industries"
            :value="option.value"
            :key="option.value"
          >
            {{ option.display }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <p>PID</p>
        <input class="form-control" type="text" v-model="pid" />
      </div>
<!--       <div class="form-group col-md-6">
        <p>居住地</p>
        <select
          class="form-control"
          name="residence_area"
          v-model="residence_area"
        >
          <option value=""></option>
          <option
            v-for="option in this.prefs"
            :value="option.code"
            :key="option.code"
          >
            {{ option.name + " - " + option.name_r }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <p>国籍</p>
        <select class="form-control" name="nationality" v-model="nationality">
          <option value=""></option>
          <option
            v-for="option in this.countries"
            :value="option.code"
            :key="option.code"
          >
            {{ option.name + " - " + option.name_en }}
          </option></select
        >
      </div>
      <div class="form-group col-md-6">
        <p>在留資格</p>
        <select class="form-control" name="visa_status" v-model="visa_status">
          <option value=""></option>
          <option
            v-for="option in this.zairyuu"
            :value="option.name"
            :key="option.name"
          >
            {{ option.name + " - " + option.name_en }}
          </option>
        </select>
      </div> -->
      <div class="form-group col-md-12">
        <input v-model="choysanAccountOnly" type="checkbox" />
        c.choysanアカウントと連携しているユーザのみ表示
      </div>
    </div>
    <div class="pb-4">
      <div class="text-right">
        <button class="btn btn-primary mr20" @click="clear">
          クリア
        </button>
        <button class="btn btn-primary" @click="search">
          対象ユーザを抽出
        </button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.usersCsv"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div>
      <div v-if="loading" class="form-row mb30">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="userTable"
          :items="users"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(契約番号)="data">
            <router-link
              :to="{
                name: 'ContractDetails',
                query: { contractId: data.item.契約番号 },
              }"
              >{{ data.item.契約番号 }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="userTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import zairyuu from "@/constants/ZairyuStatusEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "Notifications",
  mixins: [utils, master, sex, countries, prefs, zairyuu],
  computed: {
    rows() {
      return this.users.length;
    },
  },
  data() {
    return {
      card_type: "",
      sexfilter: "",
      valid_member_flag: false,
      industry: "",
      pid: "",
      residence_area: "",
      nationality: "",
      visa_status: "",
      choysanAccountOnly: false,
      csvCurrentFields: {
        契約番号: { title: "契約番号" },
        カナ英字氏名: { title: "カナ英字氏名" },
        漢字氏名: { title: "漢字氏名" },
        POPINFOID: { title: "POPINFOID" },
      },
      currentPage: 1,
      perPage: 10,
      fileName: "pushUsers",
      labels: [],
      loading: false,
      users: [],
      usersCsv: [],
      popinfoIdData: [],
      paymentMethodData: [],
      db: firebase.firestore(),
    };
  },
  components: {
    VueJsonToCsv,
  },
  watch: {
    currentPage(value) {
      sessionStorage.currentPageNotifications = value;
    },
  },
  created: function() {
    let minutes = 5;
    let saved = sessionStorage.getItem("saved");
    if (saved && new Date().getTime() - saved > minutes * 60 * 1000) {
      sessionStorage.clear();
    }
    let usersSessionStorage = sessionStorage.getItem("usersNotifications");
    if (usersSessionStorage !== null) {
      this.currentPage =
        sessionStorage.currentPageNotifications == null
          ? 1
          : sessionStorage.currentPageNotifications;
      this.card_type = sessionStorage.card_type;
      this.sexfilter = sessionStorage.sexfilter;
      this.valid_member_flag = JSON.parse(sessionStorage.valid_member_flag);
      this.industry = sessionStorage.industry;
      this.pid = sessionStorage.pid;
      this.residence_area = sessionStorage.residence_area;
      this.nationality = sessionStorage.nationality;
      this.visa_status = sessionStorage.visa_status;
      this.choysanAccountOnly = JSON.parse(sessionStorage.choysanAccountOnly);
      this.users = JSON.parse(usersSessionStorage);
      this.usersCsv = this.users;
      this.loading = false;
    }
  },
  methods: {
    clear() {
      this.card_type = "";
      this.sexfilter = "";
      this.valid_member_flag = false;
      this.industry = "";
      this.pid = "";
      this.residence_area = "";
      this.nationality = "";
      this.visa_status = "";
      this.choysanAccountOnly = false;
      this.init();
      this.loading = false;
    },
    orderByContractNumber(a, b) {
      if (a.契約番号 > b.契約番号) {
        return 1;
      } else if (a.契約番号 < b.契約番号) {
        return -1;
      }
      return 0;
    },
    init() {
      this.users = [];
      this.usersCsv = [];
      this.popinfoIdData = [];
      this.paymentMethodData = [];
      this.key = this.key ? 0 : 1;
      this.loading = true;
    },
    async loadPopInfoID() {
      let snapshot = await this.db.collection("applicationUsers").get();
      snapshot.forEach((doc) => {
        let data = doc.data();
        this.popinfoIdData[data.application_user_id] = data.popinfoID;
      });
    },
    async loadPaymentMethod() {
      const snapshot = await this.db.collection("paymentMethod").get();
      snapshot.forEach((doc) => {
        let data = doc.data();
        this.paymentMethodData[data.contract_number] = data.application_user_id;
      });
    },
    async search() {
      this.init();
      await this.loadPopInfoID();
      await this.loadPaymentMethod();
      let applicationSearchParams = {
        card_type: this.card_type,
        gender: this.sexfilter,
      };
      let choysanSearchParams = {
        redirectId: this.industry,
        pid: this.pid,
        pref_code: this.residence_area,
        country_code: this.nationality,
        zairyuuShikaku: this.visa_status,
      };
      if (
        this.industry == "" &&
        this.pid == "" &&
        this.residence_area == "" &&
        this.nationality == "" &&
        this.visa_status == "" &&
        this.choysanAccountOnly == false
      ) {
        // search applicationUsers
        this.loadApplicationUsers(applicationSearchParams);
      } else {
        //combine both collection
        this.loadCollection(applicationSearchParams, choysanSearchParams);
      }
    },
    loadApplicationUsers(applicationSearchParams) {
      let queryApplicationData = this.db.collection("master");
      for (const [key, value] of Object.entries(applicationSearchParams)) {
        if (value !== "" && value !== undefined) {
          queryApplicationData = queryApplicationData.where(key, "==", value);
        }
      }
      if (this.valid_member_flag == true) {
        queryApplicationData = queryApplicationData.where(
          "valid_member_flag",
          "==",
          "1"
        );
      }
      queryApplicationData
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              let item = {
                契約番号: data.contract_number,
                カナ英字氏名: data.kana_name,
                漢字氏名: data.kanji_name,
              };

              let appUserId = this.paymentMethodData[data.contract_number];
              if (appUserId !== undefined) {
                let popInfoID = this.popinfoIdData[appUserId];
                if (popInfoID !== undefined) item.POPINFOID = popInfoID;
                else item.POPINFOID = "";
              } else item.POPINFOID = "";

              this.users.push(item);
            }
          });
        })
        .then(() => {
          sessionStorage.setItem(
            "usersNotifications",
            JSON.stringify(this.users)
          );
          sessionStorage.card_type = this.card_type;
          sessionStorage.sexfilter = this.sexfilter;
          sessionStorage.valid_member_flag = this.valid_member_flag;
          sessionStorage.industry = this.industry;
          sessionStorage.pid = this.pid;
          sessionStorage.residence_area = this.residence_area;
          sessionStorage.nationality = this.nationality;
          sessionStorage.visa_status = this.visa_status;
          sessionStorage.choysanAccountOnly = this.choysanAccountOnly;
          sessionStorage.setItem("saved", new Date().getTime());
          this.usersCsv = this.users;
          this.loading = false;
        });
    },
    loadCollection(applicationSearchParams, choysanSearchParams) {
      let applicationCollection = [];
      let choysanCollection = [];
      let queryApplicationData = this.db.collection("master");
      for (const [key, value] of Object.entries(applicationSearchParams)) {
        if (value !== "" && value !== undefined) {
          queryApplicationData = queryApplicationData.where(key, "==", value);
        }
      }
      if (this.valid_member_flag == true) {
        queryApplicationData = queryApplicationData.where(
          "valid_member_flag",
          "==",
          "1"
        );
      }
      queryApplicationData.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.exists) {
            var data = doc.data();
            /*             if (data.mobile_0 !== undefined) {
              applicationCollection[data.mobile_0] = {
                契約番号: data.contract_number,
                カナ英字氏名: data.kana_name,
                漢字氏名: data.kanji_name,
                POPINFOID: data.popinfoId,
                mobile_0: data.mobile_0,
              };
            } else { */
            let item = {
              契約番号: data.contract_number,
              カナ英字氏名: data.kana_name,
              漢字氏名: data.kanji_name,
            };
            let appUserId = this.paymentMethodData[data.contract_number];
            if (appUserId !== undefined) {
              let popInfoID = this.popinfoIdData[appUserId];
              if (popInfoID !== undefined) {
                item.POPINFOID = popInfoID;
              } else {
                item.POPINFOID = "";
              }
            }
            else item.POPINFOID = "";
            applicationCollection[data.contract_number] = item;
            //}
          }
        });
      });
      let querychoysanData = this.db
        .collection("users")
        .where("status", "==", "1");

      for (const [key, value] of Object.entries(choysanSearchParams)) {
        if (value !== "" && value !== undefined) {
          querychoysanData = querychoysanData.where(key, "==", value);
        }
      }
      querychoysanData
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.phone !== "" && data.phone !== undefined) {
                choysanCollection[data.phone] = true;
              }
            }
          });
        })
        .then(() => {
          for (let item in choysanCollection) {
            if (applicationCollection[item] !== undefined) {
              var data = applicationCollection[item];
              this.users.push({
                契約番号: data.契約番号,
                カナ英字氏名: data.カナ英字氏名,
                漢字氏名: data.漢字氏名,
                POPINFOID: data.POPINFOID,
              });
            }
          }
          let temp = this.users.sort(this.orderByContractNumber);
          this.users = temp;
          sessionStorage.setItem(
            "usersNotifications",
            JSON.stringify(this.users)
          );
          sessionStorage.card_type = this.card_type;
          sessionStorage.sexfilter = this.sexfilter;
          sessionStorage.valid_member_flag = this.valid_member_flag;
          sessionStorage.industry = this.industry;
          sessionStorage.pid = this.pid;
          sessionStorage.residence_area = this.residence_area;
          sessionStorage.nationality = this.nationality;
          sessionStorage.visa_status = this.visa_status;
          sessionStorage.choysanAccountOnly = this.choysanAccountOnly;
          sessionStorage.setItem("saved", new Date().getTime());

          this.usersCsv = this.users;
          this.loading = false;
        });
    },
  },
};
</script>
